/* ============================================================
   YODO OS — windowing behavior
   Progressive enhancement: everything works as real links/pages
   without this file. This adds the draggable-desktop layer.
   ============================================================ */
   (function () {
    'use strict';
  
    // Bail on the desktop metaphor for touch / small screens — the CSS
    // already stacks windows; we just skip drag + launch there.
    var isDesktop = window.matchMedia('(min-width: 901px)').matches;
  
    var z = 40;
  
    function makeDrag(el, handle, closeEl) {
      if (!el || !handle) return;
      el.addEventListener('mousedown', function () { el.style.zIndex = ++z; });
      var dragging = false, ox = 0, oy = 0;
      handle.addEventListener('mousedown', function (e) {
        if (closeEl && e.target === closeEl) return;
        dragging = true;
        ox = e.clientX - el.offsetLeft;
        oy = e.clientY - el.offsetTop;
        handle.style.cursor = 'grabbing';
        e.preventDefault();
      });
      document.addEventListener('mousemove', function (e) {
        if (!dragging) return;
        el.style.left = (e.clientX - ox) + 'px';
        el.style.top = (e.clientY - oy) + 'px';
      });
      document.addEventListener('mouseup', function () {
        dragging = false;
        handle.style.cursor = 'grab';
      });
      if (closeEl) {
        closeEl.addEventListener('click', function (e) {
          e.preventDefault();
          el.style.display = 'none';
        });
      }
    }
  
    document.addEventListener('DOMContentLoaded', function () {
  
      // --- windows: drag + focus + active/inactive states ---
      if (isDesktop) {
        var allWins = document.querySelectorAll('.win');
        function focusWin(win) {
          allWins.forEach(function (w) { w.classList.add('inactive'); });
          win.classList.remove('inactive');
          var b = win.querySelector('.titlebar');
          document.querySelectorAll('.titlebar').forEach(function (t) { t.classList.remove('active'); });
          if (b) b.classList.add('active');
          win.style.zIndex = ++z;
        }
        allWins.forEach(function (w) {
          var bar = w.querySelector('.titlebar');
          makeDrag(w, bar, w.querySelector('.closebox'));
          w.addEventListener('mousedown', function () { focusWin(w); });
  
          // WindowShade: double-click the title bar to roll the window up/down
          if (bar) {
            bar.addEventListener('dblclick', function (e) {
              // ignore double-clicks that land on the close/collapse boxes
              if (e.target.closest('.closebox, .collapsebox')) return;
              w.classList.toggle('shaded');
            });
          }
          // the collapse box (top-right) also toggles shade, like real OS 9
          var collapse = w.querySelector('.collapsebox');
          if (collapse) {
            collapse.addEventListener('click', function (e) {
              e.stopPropagation();
              w.classList.toggle('shaded');
            });
          }
        });
        var desk = document.querySelector('.yodo-desktop');
        if (desk) {
          desk.addEventListener('mousedown', function (e) {
            if (!e.target.closest('.win')) {
              allWins.forEach(function (w) { w.classList.add('inactive'); });
              document.querySelectorAll('.titlebar').forEach(function (t) { t.classList.remove('active'); });
            }
          });
        }
  
        document.querySelectorAll('.sticky').forEach(function (s) {
          makeDrag(s, s.querySelector('.sbar'), s.querySelector('.sclose'));
        });
      }
  
      // --- live clock in menu bar ---
      var clock = document.getElementById('yodo-clock');
      if (clock) {
        var tick = function () {
          var d = new Date(), h = d.getHours(), ap = h >= 12 ? 'PM' : 'AM';
          h = h % 12 || 12;
          clock.textContent = h + ':' + String(d.getMinutes()).padStart(2, '0') + ' ' + ap;
        };
        tick();
        setInterval(tick, 10000);
      }
  
      // --- Enter the catalog: launch big + dim desktop ---
      var dimmer = document.getElementById('yodo-dimmer');
      var catalog = document.getElementById('win-catalog');
      var enterBtn = document.querySelector('[data-enter-catalog]');
  
      function launchCatalog() {
        if (!catalog) return;
        if (isDesktop && dimmer) {
          dimmer.classList.add('on');
          catalog.style.zIndex = ++z;
          catalog.classList.add('launched', 'launching');
          setTimeout(function () { catalog.classList.remove('launching'); }, 360);
        } else if (catalog) {
          catalog.scrollIntoView({ behavior: 'smooth' });
        }
      }
      function dismissCatalog() {
        if (!catalog) return;
        if (dimmer) dimmer.classList.remove('on');
        catalog.classList.remove('launched');
        catalog.style.transform = '';
      }
      if (enterBtn) {
        enterBtn.addEventListener('click', function (e) { e.preventDefault(); launchCatalog(); });
      }
      if (dimmer) dimmer.addEventListener('click', dismissCatalog);
      if (catalog) {
        var cClose = catalog.querySelector('.closebox');
        if (cClose) cClose.addEventListener('click', dismissCatalog);
      }
  
      // --- Catalog row click -> open that coffee's Info window ---
      // Data comes from data-* attributes rendered by Liquid, so no
      // product data is hardcoded here.
      var info = document.getElementById('win-origin');
      if (info) {
        var iTitle = info.querySelector('[data-o-title]');
        var iName = info.querySelector('[data-o-name]');
        var iRec = info.querySelector('[data-o-rec]');
        var iIcon = info.querySelector('[data-o-icon]');
        var iWell = info.querySelector('[data-o-well]');
        var iDesc = info.querySelector('[data-o-desc]');
        var iBuy = info.querySelector('[data-o-buy]');
  
        document.querySelectorAll('#win-catalog .row').forEach(function (row) {
          row.addEventListener('click', function (e) {
            // let the "Add" button and real product links behave normally
            if (e.target.closest('.ad')) return;
            if (window.__yodoJustDragged) return; // a drag-to-trash just happened
            if (!isDesktop) return; // on mobile, the row is a real link to the product page
            e.preventDefault();
  
            var name = row.getAttribute('data-name') || '';
            var sub = row.getAttribute('data-sub') || '';
            var iconSrc = row.querySelector('.ic img');
            var specs = row.getAttribute('data-specs') || ''; // "Farm|Finca||Region|Nicoya||..."
            var desc = row.getAttribute('data-desc') || '';
            var rec = row.getAttribute('data-rec') || '';
            var url = row.getAttribute('data-url') || row.getAttribute('href') || '';
  
            if (iTitle) iTitle.textContent = name;
            if (iName) iName.textContent = name;
            if (iRec) iRec.textContent = rec;
            if (iIcon && iconSrc) iIcon.src = iconSrc.src;
            if (iDesc) iDesc.textContent = desc;
            if (iBuy) {
              iBuy.setAttribute('href', url || '#');
              var variant = row.getAttribute('data-variant') || '';
              if (variant) {
                iBuy.setAttribute('data-add', variant);
                iBuy.textContent = 'Add to Cart';
                iBuy.classList.remove('is-soon');
              } else {
                iBuy.removeAttribute('data-add');
                iBuy.textContent = row.getAttribute('data-soon-label') || 'Coming Soon';
                iBuy.classList.add('is-soon');
              }
            }
            if (iWell) {
              iWell.innerHTML = specs.split('||').filter(Boolean).map(function (pair) {
                var kv = pair.split('|');
                var hl = kv[2] === 'hl' ? ' hl' : '';
                return '<div class="frow"><span class="k">' + (kv[0] || '') +
                       '</span><span class="v' + hl + '">' + (kv[1] || '') + '</span></div>';
              }).join('');
            }
  
            info.style.display = '';
            info.style.zIndex = ++z;
            info.style.left = '50%';
            info.style.marginLeft = '-150px';
            info.style.top = '150px';
            info.classList.remove('shaded');
            info.classList.add('launching-info');
            setTimeout(function () { info.classList.remove('launching-info'); }, 320);
          });
        });
      }
    });
  })();